import React from 'react';
import { connect } from 'react-redux';
import MediaPickerImageCard from '../../../common/MediaPickerImageCard';
import { createActions } from '../../../../store';

const ImageElementStockImagesCard = (props) => {
    const {
        galleryCardWidth, galleryCardHeight, imageStockImage, onImageSelect,
        savingInProgress, showCriticalOperationProgressWarning, isVideoExportsQueued
    } = props;

    const onImageClick = () => {
        if (savingInProgress) {
            showCriticalOperationProgressWarning();
            return;
        }

        if (isVideoExportsQueued())
            return;

        if (onImageSelect) {
            onImageSelect(imageStockImage);
        }
    };

    return (
        <MediaPickerImageCard
            image={imageStockImage}
            galleryCardWidth={galleryCardWidth}
            galleryCardHeight={galleryCardHeight}
            onImageClick={onImageClick}
        />
    );
};

const mapStateToProps = (state, ownProps) => {
    const imageStockImage = (state.mediaPicker.imageElementStockImages || state.mediaPicker.imageStockImages)[ownProps.index];
    const { savingInProgress } = state.create.videoSavingState;
    return { imageStockImage, savingInProgress };
};

const mapDispatchToProps = (dispatch) => {
    const isVideoExportsQueued = () => dispatch(createActions.isVideoExportsQueued());
    const showCriticalOperationProgressWarning = () => dispatch(createActions.showCriticalOperationProgressWarning());

    return {
        isVideoExportsQueued,
        showCriticalOperationProgressWarning
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ImageElementStockImagesCard);
